import { Popover, Progress, Table, Tag, Tooltip } from "antd"
import { get } from "lodash"
import React, { useEffect } from "react"
import {
  HISTORICAL_ANALYSIS,
  WORKING_ENVIRONMENT_LABEL,
} from "../../utils/constants"
import { isModuleBySlug } from "../../utils/storage"
import questionIcon from "images/question.svg"
import imgMark from "images/mark_item.svg"

import "./index.less"
import Bubbles from "../Bubbles"
import { truncateText, validate } from "../../utils/functions"
import { loadTexts, sanitize } from "../../utils/i18n"
import { verifyFeatureFlag } from "../../utils/feature-flags"

const ResultByDimensionV2 = (props) => {
  const intlresultByDimension = loadTexts("reports_dimensions_view")
    .contentBottomDimension.resultByDimensionv2
  const [finalData, setFinalData] = React.useState([])
  useEffect(() => {
    const { data } = props
    const helperData = data.filter((item) => !item.engagement)
    setFinalData(helperData)
  }, [props.data])
  const contentVariation = (
    <div className="content-variation">
      <p>{sanitize(intlresultByDimension.tooltipVariation.content)}</p>
      <div>
        <div className="content-variation__triangle content-variation__triangle--positive" />
        {intlresultByDimension.tooltipVariation.variationPositive}
      </div>
      <div>
        <div className="content-variation__triangle" />
        {intlresultByDimension.tooltipVariation.variationNegative}
      </div>
    </div>
  )

  const progressBar = (record) => {
    const valueLow = validate.empty(record.value_low) ? 0 : record.value_low

    const valueMiddle = validate.empty(record.value_middle)
      ? 0
      : record.value_middle

    return (
      <div className="progress">
        <div
          className="low"
          style={{
            width: `${valueLow}%`,
            borderRadius: `${parseInt(valueLow) === 100 ? "10px" : ""}`,
          }}
        />
        <div
          className="middle"
          style={{
            width: `${valueMiddle}%`,
            borderRadius: `${parseInt(valueMiddle) === 100 ? "10px" : ""}`,
          }}
        />
      </div>
    )
  }

  const renderBubble = (text, record) => {
    return (
      <div
        className="bubble"
        style={
          parseFloat(record.impact) == 0
            ? { gridTemplateColumns: "auto auto auto" }
            : {}
        }>
        {parseFloat(record.impact) >= 0.5 ? (
          <Popover
            placement="right"
            content={intlresultByDimension.columns.highImpact}>
            <img src={imgMark} />
          </Popover>
        ) : (
          <div />
        )}

        <span
          style={
            parseFloat(record.impact) == 0
              ? { marginLeft: 0, textAlign: "center", color: "#8d8a8d" }
              : {}
          }>
          {parseFloat(record.impact) == 0 ? (
            <Tooltip title={intlresultByDimension.notSignificativeImpact}>
              <span style={{ color: "#8D8A8D" }}>-</span>
            </Tooltip>
          ) : (
            record.impact
          )}
        </span>
        {parseFloat(record.impact) != 0 ? (
          <Bubbles
            left={parseFloat(record.impact)}
            right={parseFloat(record.impact)}
          />
        ) : (
          <div />
        )}
      </div>
    )
  }
  const columns = () => {
    let baseColumns = []
    let measureWithoutSegments = false

    if (props.measureInfo.segments) {
      measureWithoutSegments = props.measureInfo.segments.length == 0
    }

    if (props.bubble && props.measureInfo.employees>20  && (props.idSegment || measureWithoutSegments)) {
      baseColumns = [
        ...baseColumns,
        {
          title: intlresultByDimension.columns.impact,
          dataIndex: "bubbles",
          render: renderBubble,
          width: "112px",
        },
      ]
    }


    baseColumns = [
      ...baseColumns,
      {
        title: intlresultByDimension.columns.dimensions,
        dataIndex: "dimensions",
        render: (text, record) => record.question_name || record.dimension_name,
        width: "450px",
        ellipsis: true,
      }
    ]

    if(verifyFeatureFlag('seg2-5') && props.measureInfo.id_scope_type == 2 && props.measureInfo.new_version >= 1 && props.idSegment == null) {
      baseColumns = [
        ...baseColumns,
        {
          title: 'Segmento',
          dataIndex: 'segments',
          render: (text, record) =>{
            let segmentsText = truncateText(record.segments, 20)
            return <Tooltip placement="top" title={record.segments}>{segmentsText}</Tooltip>
          },
          width: '185px'
        }
      ]
    }

    baseColumns = [
      ...baseColumns,
      {
        title: props.measureInfo.survey_type_name,
        dataIndex: "metric_total_label",
        render: (text, record) =>
          record.anonymity_check.valid ? (
            <Tag color={record.color}>
              {record.value_visible && !String(record.value_visible).endsWith('%') 
                ? `${record.value_visible}%` 
                : record.value_visible}
            </Tag>
          ) : (
            "-"
          ),
        width: "143px",
        sorter: (a, b) => a.value - b.value,
      },
    ]

    if (props.measureInfo.id_survey_calculation_type === 1) {
      const topTwoBoxColumns = [
        {
          title: "1 - 2",
          dataIndex: "value_1_2",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <span className="value_text">{record.value_low_visible}</span>
            ) : (
              "-"
            ),
          width: "60px",
        },
        {
          title: "3",
          dataIndex: "value_3",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <span className="value_text">{record.value_middle_visible}</span>
            ) : (
              "-"
            ),
          width: "60px",
        },
        {
          title: "4 - 5",
          dataIndex: "value_4_5",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <span className="value_text">
            {record.value_visible == null
              ? ''
              : (String(record.value_visible).trim().endsWith('%')
                  ? String(record.value_visible).trim()
                  : `${String(record.value_visible).trim()}%`)}
          </span>
            ) : (
              "-"
            ),
          width: "60px",
        },
        {
          title: intlresultByDimension.columns.distribution,
          dataIndex: "distribution",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <div className="columnProgressBar">{progressBar(record)}</div>
            ) : (
              "-"
            ),
          width: "156px",
        },
      ]
      baseColumns = [...baseColumns, ...topTwoBoxColumns]
    } else {
      const averageColumns = [
        {
          title: "1",
          dataIndex: "p1",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <span className="value_text">
                {get(record, "values_avg.p1", "0%")}
              </span>
            ) : (
              "-"
            ),
          width: "60px",
        },
        {
          title: "2",
          dataIndex: "p2",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <span className="value_text">
                {get(record, "values_avg.p2", "0%")}
              </span>
            ) : (
              "-"
            ),
          width: "60px",
        },
        {
          title: "3",
          dataIndex: "p3",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <span className="value_text">
                {get(record, "values_avg.p3", "0%")}
              </span>
            ) : (
              "-"
            ),
          width: "60px",
        },
        {
          title: "4",
          dataIndex: "p4",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <span className="value_text">
                {get(record, "values_avg.p4", "0%")}
              </span>
            ) : (
              "-"
            ),
          width: "60px",
        },
        {
          title: "5",
          dataIndex: "p5",
          render: (text, record) =>
            record.anonymity_check.valid ? (
              <span className="value_text">
                {get(record, "values_avg.p5", "0%")}
              </span>
            ) : (
              "-"
            ),
          width: "60px",
        },
      ]
      baseColumns = [...baseColumns, ...averageColumns]
    }

    if (props.showVariation && !props.ifFirst) {
      baseColumns = [
        ...baseColumns,
        {
          title: () => (
            <span>
              {`${intlresultByDimension.columns.previousMeasure} `}
              <Popover placement="bottomRight" content={contentVariation}>
                <img
                  src={questionIcon}
                  alt="question"
                  style={{ marginLeft: 4, cursor: "pointer" }}
                />
              </Popover>
            </span>
          ),
          dataIndex: "previous",
          render: (text, record) => {
            if (record.prev_value === "") {
              return "-"
            }

            if (!record.anonymity_check.valid) {
              return "-"
            }

            return (
              <span>
                <strong>
                  {get(record, "prev_value", "") && !String(get(record, "prev_value", "")).endsWith('%') 
                    ? `${get(record, "prev_value", "")}%` 
                    : get(record, "prev_value", "")}
                </strong>

                {get(record, "variation", 0) !== 0 && (
                  <>
                    <span
                      className={`${
                        get(record, "variation", 0) > 0
                          ? "green-text"
                          : "red-text"
                      }`}>
                      {get(record, "variation_display", "")}
                    </span>
                    <div
                      className={`triangle ${
                        get(record, "variation", 0) > 0
                          ? "triangle--positive"
                          : ""
                      }`}
                    />
                  </>
                )}
              </span>
            )
          },
          width: "120px",
        },
      ]
    }

    if (props.showBenchmark) {
      baseColumns = [
        ...baseColumns,
        {
          title: intlresultByDimension.columns.benchmark,
          dataIndex: "benchmark",
          render: (text, record) => {
            if (record.benchmark) {
              if (!record.benchmark.show) {
                return "-"
              }

              if (!record.anonymity_check.valid) {
                return "-"
              }

              return (
                <span>
                  <strong>{get(record, "benchmark.value", "")} </strong>

                  {get(record, "benchmark.variation", 0) !== 0 && (
                    <>
                      <span
                        className={`${
                          get(record, "benchmark.level", false) ==true
                            ? "green-text"
                            : "red-text"
                        }`}>
                        {get(record, "benchmark.variation", 0)} %
                      </span>
                      <div
                        className={`triangle ${
                          get(record, "benchmark.level", false) ==true
                            ? "triangle--positive"
                            : ""
                        }`}
                      />
                    </>
                  )}
                </span>
              )
            }
            return "-"
          },
          width: "120px",
        },
      ]
    }

    return baseColumns
  }


  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <Table
        bordered
        size="small"
        columns={columns()}
        rowKey={(record) => {
          if (record.id_question) {
            return record.id_question
          }
          return record.id_dimension
        }}
        dataSource={finalData}
        expandable={{
          childrenColumnName: props.isExpandable ? "childs" : "",
          expandIconColumnIndex:
            props.bubble && props.measureInfo.employees>20 &&
            (props.idSegment || props.measureInfo.segments?.length == 0)
              ? 1
              : 0,
        }}
      />
    </div>
  )
}

export default ResultByDimensionV2
